import { useSearchParams } from "react-router-dom";
import { BarChart3, Wallet } from "lucide-react";
import Dashboard from "@/pages/Dashboard";
import FinanceDashboard from "@/pages/FinanceDashboard";

const STORE_KEY = "ss_dashboard_view";
const VIEWS = [
  { key: "sales", label: "Penjualan", icon: BarChart3 },
  { key: "finance", label: "Keuangan", icon: Wallet },
];

/** Owner & sales director can flip between the sales and the finance dashboard. */
export default function DashboardSwitch() {
  const [params, setParams] = useSearchParams();
  const view = params.get("view") === "finance" || (!params.get("view") && localStorage.getItem(STORE_KEY) === "finance") ? "finance" : "sales";

  const pick = (v) => {
    localStorage.setItem(STORE_KEY, v);
    const next = new URLSearchParams(params);
    next.set("view", v);
    setParams(next, { replace: true });
  };

  return (
    <div className="space-y-5" data-testid="dashboard-switch">
      <div className="inline-flex items-center gap-1 p-1 rounded-full bg-black/[0.04] border border-white/60">
        {VIEWS.map((v) => {
          const active = view === v.key;
          return (
            <button
              key={v.key}
              onClick={() => pick(v.key)}
              data-testid={`dashboard-view-${v.key}`}
              className={`inline-flex items-center gap-2 h-9 px-5 rounded-full text-xs font-bold transition-all ${
                active ? "bg-[#090808] text-white shadow-[0_6px_16px_-8px_rgba(9,8,8,0.5)]" : "text-[#626061] hover:text-[#090808]"
              }`}
            >
              <v.icon className="w-3.5 h-3.5" strokeWidth={2} /> {v.label}
            </button>
          );
        })}
      </div>

      {view === "finance" ? <FinanceDashboard /> : <Dashboard />}
    </div>
  );
}
